// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 279 ? "6c44d60f" : chunkId) + "." + {"229":"d48d4ac0c7b45ffd","279":"46b1792303888103","745":"91f4afd2fa2d1179"}[chunkId] + ".js";
};